import { CreateOptionsParams, ISpecializedCombo, useCombo } from "@hooks/useCombo";
import { MenuItem } from "@material-ui/core";
import { useClienteEventoService } from "@services/ClienteEventoService";
import { useThemeColor } from "@themes/Colors";
import { KeyOfEnum } from "@utils/TypeHelpers";
import React from "react";

export enum EnumClienteEventoStatus {
    None = "0",
    Registrado = 1,
    Cancelado = 2
}

export interface IClienteEventoStatus {
    clienteEventoStatusId: number,
    nome: string,
    ativo: string
}

export type IComboClienteEventoStatus = ISpecializedCombo<IClienteEventoStatus>;

export function useClienteEventoStatusCombo (initialValue?: EnumClienteEventoStatus) : IComboClienteEventoStatus {
    const combo = useCombo<IClienteEventoStatus>({
        value: initialValue
    });

    const clienteEventoService = useClienteEventoService();

    const createOptions = React.useCallback((params?: CreateOptionsParams) => {
        return combo.set.map((clienteEventoStatus, index) => {
            return <MenuItem key={index} value={clienteEventoStatus.clienteEventoStatusId}>{params?.prefix}{clienteEventoStatus.nome}{params?.sufix}</MenuItem>
        });
    }, [combo.set]);

    const loadOptions = React.useCallback(() => {
        combo.load(clienteEventoService.listarStatusAtivos)
    }, [combo, clienteEventoService.listarStatusAtivos]);

    return React.useMemo(() => ({
        ...combo, createOptions, loadOptions
    }), [combo, createOptions, loadOptions]);

}
export function useClienteEventoStatusColor () {
    const themeColor = useThemeColor();

    const map : KeyOfEnum<EnumClienteEventoStatus, string> = React.useMemo(() => ({
        [EnumClienteEventoStatus.None]: "",
        [EnumClienteEventoStatus.Registrado]: themeColor.status.verde,
        [EnumClienteEventoStatus.Cancelado]: themeColor.status.cinza
    }), [themeColor.status.cinza, themeColor.status.verde]);

    return React.useMemo(() => map, [map]);
}